import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { format } from 'date-fns';

import { Avatar } from 'uiToolkitV1/Avatar';
import { RichTextEditor2 } from 'uiToolkitV1/RichTextEditor2';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

type ViewViolationDetailsProps = {
  isEmployeeView: boolean;
  raisedFor: string;
  raisedForAvatar: string;
  type: string;
  severity: string;
  raisedBy: string;
  raisedByAvatar: string;
  raisedByRole: string;
  reportedTime: string;
  description: string;
};

export const ViewViolationDetails = ({
  isEmployeeView,
  raisedFor,
  raisedForAvatar,
  type,
  severity,
  raisedBy,
  raisedByAvatar,
  raisedByRole,
  reportedTime,
  description,
}: ViewViolationDetailsProps) => {
  const date = format(new Date(reportedTime), 'MMM d, yyyy');
  const time = format(new Date(reportedTime), 'h:mm a');

  // SHOWN ONLY ON EMPLOYEE VIEW
  if (isEmployeeView) {
    return (
      <Flex flexDir="column" h="fit-content" gap="12px">
        <Flex flexDir="column" gap="12px">
          <TextLabel color="text.g2">Reported by</TextLabel>
          <Flex alignItems="center" gap="8px">
            <Avatar size={24} src={raisedByAvatar} name={raisedBy} />
            <Flex flexDir="column">
              <TextBodyMedium>{raisedBy}</TextBodyMedium>
              <TextLabel color="text.g2">{raisedByRole}</TextLabel>
            </Flex>
          </Flex>
        </Flex>
        <Grid
          templateColumns={{
            base: '1fr',
            desktop: 'repeat(2, 1fr)',
          }}
          gap="12px"
        >
          <GridItem>
            <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
              <TextLabel color="text.g2">Date & time</TextLabel>
              <Flex gap="4px" alignItems="center" py={{ base: '5px', desktop: '10px' }}>
                <TextBodyMedium>{date}</TextBodyMedium>
                <TextBodyMedium>•</TextBodyMedium>
                <TextBodyMedium>{time}</TextBodyMedium>
              </Flex>
            </Flex>
          </GridItem>
          <GridItem>
            <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
              <TextLabel color="text.g2">Type</TextLabel>
              <TextBodyMedium py={{ base: '5px', desktop: '10px' }}>{type}</TextBodyMedium>
            </Flex>
          </GridItem>
        </Grid>
        <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
          <TextLabel color="text.g2">Description</TextLabel>
          <RichTextEditor2
            content={description}
            disabled
            showMenuBar={false}
            onChange={() => {}}
            onOutsideClick={() => {}}
            containerProps={{
              border: '0!important',
              sx: {
                '& .rte-editor-2': {
                  padding: { base: '4px 0 0 0 !important', desktop: '8px 0 0 0 !important' },
                  minHeight: 'unset !important',
                },
              },
            }}
          />
        </Flex>
      </Flex>
    );
  }

  // SHOW ON MANAGER AND ADMIN VIEW
  return (
    <Flex
      flexDir="column"
      h="fit-content"
      p="12px"
      gap="12px"
      border="1px solid"
      borderColor="border.EBEFF3"
      borderRadius="8px"
    >
      <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
        <TextLabel color="text.g2">Reported employee</TextLabel>
        <Flex gap="8px" alignItems="center" py={{ base: '5px', desktop: '10px' }}>
          <Avatar size={24} src={raisedForAvatar} name={raisedFor} />

          <TextBodyMedium>{raisedFor}</TextBodyMedium>
        </Flex>
      </Flex>
      <Grid
        templateColumns={{
          base: '1fr',
          desktop: 'repeat(2, 1fr)',
        }}
        gap="12px"
      >
        <GridItem>
          <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
            <TextLabel color="text.g2">Type</TextLabel>
            <TextBodyMedium py={{ base: '5px', desktop: '10px' }}>{type}</TextBodyMedium>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
            <TextLabel color="text.g2">Severity</TextLabel>
            <TextBodyMedium py={{ base: '5px', desktop: '10px' }}>{severity}</TextBodyMedium>
          </Flex>
        </GridItem>
      </Grid>
      <Grid
        templateColumns={{
          base: '1fr',
          desktop: 'repeat(2, 1fr)',
        }}
        gap="12px"
      >
        <GridItem>
          <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
            <TextLabel color="text.g2">Reported by</TextLabel>
            <Flex gap="8px" alignItems="center" py={{ base: '5px', desktop: '10px' }}>
              <Avatar size={24} src={raisedByAvatar} name={raisedBy} />

              <TextBodyMedium>{raisedBy}</TextBodyMedium>
            </Flex>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" gap={{ base: '2px', desktop: '4px' }}>
            <TextLabel color="text.g2">Date & time</TextLabel>
            <Flex gap="4px" alignItems="center" py={{ base: '5px', desktop: '10px' }}>
              <TextBodyMedium>{date}</TextBodyMedium>
              <TextBodyMedium>•</TextBodyMedium>
              <TextBodyMedium>{time}</TextBodyMedium>
            </Flex>
          </Flex>
        </GridItem>
      </Grid>
      <Flex flexDir="column" gap="4px">
        <TextLabel color="text.g2">Description</TextLabel>
        <RichTextEditor2
          content={description}
          disabled
          showMenuBar={false}
          onChange={() => {}}
          onOutsideClick={() => {}}
          containerProps={{
            border: '0!important',
            sx: {
              '& .rte-editor-2': {
                padding: { base: '4px 0 0 0 !important', desktop: '8px 0 0 0 !important' },
                minHeight: 'unset !important',
              },
            },
          }}
        />
      </Flex>
    </Flex>
  );
};
